import "./App.css";
import { LanguageProvider } from "./LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import EspacioSection from "./components/EspacioSection";
import EventosSection from "./components/EventosSection";
import GaleriaSection from "./components/GaleriaSection";
import ServiciosSection from "./components/ServiciosSection";
import TestimoniosSection from "./components/TestimoniosSection";
import UbicacionSection from "./components/UbicacionSection";
import ContactoSection from "./components/ContactoSection";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <main>
          <HeroSection />
          <EspacioSection />
          <EventosSection />
          <GaleriaSection />
          <ServiciosSection />
          <TestimoniosSection />
          <UbicacionSection />
          <ContactoSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
